import { apiPost } from "./client";

export function submitContact(payload) {
  return apiPost("/contact", payload);
}
